import { Dispatch, SetStateAction } from 'react';
import { CustomRadio, ListSkeleton } from '../../../components';
import { OrderPricelist, Pricing } from '@zonofi/zono-money-store';
import './price-list-drawer-content.scss';
import { TouchableOpacity } from '../../../common';

interface SelectPriceListDrawerContentProps {
  priceList?: Pricing[];
  selectedPricelist: OrderPricelist;
  setSelectedPricelist: Dispatch<SetStateAction<OrderPricelist>>;
  isloading?: boolean;
}

export const SelectPriceListDrawerContent: React.FC<
  SelectPriceListDrawerContentProps
> = ({ priceList, selectedPricelist, setSelectedPricelist, isloading }) => {
  if (isloading) {
    return <ListSkeleton height={20} length={6} />;
  }

  if (priceList?.length === 0 && !isloading) {
    return (
      <div className="no-price-list-items">
        <div className="no-price-list-items--text font-semibold">
          {'No price lists found'}
        </div>
      </div>
    );
  }

  return (
    <div className="price-list-drawer-content">
      {priceList &&
        priceList?.map((item) => (
          <TouchableOpacity
            key={item.priceListId}
            className="price-list-item"
            onPress={() =>
              setSelectedPricelist({
                pricelistId: item.priceListId,
                pricelistName: item.name,
              })
            }
          >
            <CustomRadio
              checked={item?.priceListId === selectedPricelist?.pricelistId}
            />
            <span className="price-list-item-name font-semibold">
              {item.name}
            </span>
          </TouchableOpacity>
        ))}
    </div>
  );
};
